import getQueryParameter from './getQueryParameter';

let seed: number = Number(getQueryParameter('seed')) || Date.now();
seed = seed ^ 0xdeadbeef;

// https://stackoverflow.com/a/47593316/5791449
function sfc32(a: number, b: number, c: number, d: number) {
  return function () {
    a >>>= 0;
    b >>>= 0;
    c >>>= 0;
    d >>>= 0;
    let t = (a + b) | 0;
    a = b ^ (b >>> 9);
    b = (c + (c << 3)) | 0;
    c = (c << 21) | (c >>> 11);
    d = (d + 1) | 0;
    t = (t + d) | 0;
    c = (c + t) | 0;
    return (t >>> 0) / 4294967296;
  };
}

export default function random() {
  return sfc32(0x9e3779b9, 0x243f6a88, 0xb7e15162, seed++)();
}
